import { useEffect, useState } from 'react';

import { useCurrentRoute } from '@luna/router';

import { isSearchStateEmpty } from './isSearchStateEmpty';
import { useSearchStateFromUrl } from './useSearchStateFromUrl';

export function useSearchMode(): boolean {
    const currentRoute = useCurrentRoute();
    const searchState = useSearchStateFromUrl();
    const [isSearch, setSearch] = useState(!isSearchStateEmpty(searchState));

    useEffect(() => {
        setSearch(!isSearchStateEmpty(searchState));
    }, [currentRoute, searchState]);

    return isSearch;
}
